module.exports = __webpack_public_path__ + "static/media/ananse.b1c863a4.png";